import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {ReceivablesBalanceService} from "../../../shared/services/receivables-balance.service";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpErrorResponse} from "@angular/common/http";
import {LoginLockService} from "../../../shared/services/login-lock.service";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-login-lock-add',
  templateUrl: './login-lock-add.component.html',
  styleUrls: ['./login-lock-add.component.scss']
})
export class LoginLockAddComponent implements OnInit, OnDestroy {

  loginLockAddForm: FormGroup;
  ofwcaControl: FormControl;
  partnerControl: FormControl;
  minutesEndAtControl: FormControl;
  minutesStartAtControl: FormControl;
  enableSaveButton = false;
  processingRequest = false;
  formErrors: any = {};
  partnerOfwcaId = null;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    public dialogRef: MatDialogRef<LoginLockAddComponent>,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private loginLockService: LoginLockService,
    private ofwcaService: OfwcaService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
  ) {
    this.loginLockAddForm = fb.group({
      minutesEndAt: this.minutesEndAtControl = fb.control('', [Validators.required]),
      minutesStartAt: this.minutesStartAtControl = fb.control('', [Validators.required]),
      }
    );
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  sendForm(): void {
    if (!this.loginLockAddForm.valid) {
      this.loginLockAddForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz aktywować blokadę logowania? Użytkownicy zostaną wylogowani z systemu za '
          + this.minutesStartAtControl.value
          +' minut oraz nie będą mogli zalogować się ponownie. '},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {


        this.processingRequest = true;

        this.formErrors = {};

        this.loginLockService.sendForm(this.loginLockAddForm.value)
          .subscribe(() => {
            this.snack.open('Pomyślnie dodano blokadę', '', {
              duration: 2000,
            });
            this.processingRequest = false;
            this.dialogRef.close();
          }, (error: HttpErrorResponse) => {
            this.processingRequest = false;
            this.snack.open('Podczas dodawania blokady wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });
            if (error.status === 400) {
              this.formErrors = error.error.error.list;
              this.formHelper.setBackendErrorState(this.loginLockAddForm, this.formErrors);
            }


          })
        ;
      }
    });
  }

}
